import { render } from "./Creditos.vue?vue&type=template&id=0a588020"
import script from "./Creditos.vue?vue&type=script&lang=js"
export * from "./Creditos.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__